import React, { FC, useEffect } from "react";
import BoxesFullScreen from "Components/delivery-management/parcel-tracking-view/boxes-fullscreen";
import TrolleyFullScreen from "Components/delivery-management/parcel-tracking-view/trolley-fullscreen";
import BoxComponent from "Components/fullscreen-configuration/box-component/box-component";
import { last } from "lodash";
import { FullscreenTypeEnums } from "Data/settings";

// ====================================================================
//   Moved from Parcel Tracking
// ====================================================================
const FullscreenTrackingView: FC<any> = (props) => {
  const {
    handleAPICallsByTabs,
    tabActiveKey,
    boxes,
    upcomingBatches,
    trolleys,
    boxesSlot,
    viewAccess = "PRIVATE",
    type,
    accessForbidden,
  } = props || {};

  //  Interval
  // =================================
  useEffect(() => {
    handleAPICallsByTabs && handleAPICallsByTabs();
    !accessForbidden;
  }, [tabActiveKey]);

  const generateComponent = () => {
    if (viewAccess === "PRIVATE") {
      switch (tabActiveKey) {
        case "1":
          return (
            <TrolleyFullScreen
              boxesToLoad={boxes || []}
              upcomingBatches={upcomingBatches || []}
              trolleyArray={trolleys || []}
            />
          );
        default:
          return <BoxesFullScreen boxesObj={boxesSlot} />;
      }
    }

    switch (type) {
      case FullscreenTypeEnums.TROLLEY:
        return (
          <TrolleyFullScreen
            boxesToLoad={boxes || []}
            upcomingBatches={upcomingBatches || []}
            trolleyArray={trolleys || []}
          />
        );
      default:
        // component is not made with reusability in mind...
        const firstItem: any = last(boxesSlot);

        const filteredColumns = firstItem?.slots ?? [];
        const noOfColumns = firstItem?.noOfColumns ?? 0;

        return (
          <div className="dm-fullscreen dm-fs-boxes">
            <BoxComponent
              filteredColumns={{ columns: filteredColumns }}
              noOfColumns={noOfColumns}
            />
          </div>
        );
    }
  };

  return <div className="fcv-content">{generateComponent()}</div>;
};

export default FullscreenTrackingView;
